import { loadDataFromCsv } from '@/utils/csvUtils';

export const loadAllRegion = async(): Promise<any> => {
  return await loadDataFromCsv('/data/regions.csv');
}

export const loadAllCountries = async(): Promise<any> => {
  return await loadDataFromCsv('/data/countries.csv', ["region", "iso2", "iso3", "nationality"]);
}

export const loadWorldCities = async(): Promise<any> => {
  return await loadDataFromCsv('/data/worldcities.csv', ["iso3"])
}
